import { Box, Card, Container, Grid } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import { toast } from 'react-toastify';
import RemoveNullObjectValue, { removeFalseValues } from 'src/utils/RemoveNullObjectValue';
import { useTranslation } from 'react-i18next';
import agentRole from 'src/pages/agentRole/selector';
import RHFTextField from '../../../components/hook-form/RHFTextField';
import FormProvider from '../../../components/hook-form/FormProvider';
import validation from './validation';
import Enum from '../enum';
import { useMutationCustom, useQueryCustom } from '../../../utils/reactQueryHooks';
import axiosInstance from '../../../utils/axios';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import WaitingBox from '../../../components/WaitingBox/index';
import persianToEnglishNumber from '../../../utils/persianToEnglishNumber';
import ProvinceSelector from 'src/components/selector/Province';
import { useDispatch, useSelector } from 'react-redux';
import { getAdminProfile } from 'src/redux/slices/user';
import RHFSelector from 'src/components/hook-form/RHFSelector';
import { CLIENT_TYPE_OP } from 'src/config';
import { RHFUploadSingleFile } from 'src/components/hook-form';
import QuestionComponent from 'src/components/ui/Question';
import ModalLayout from 'src/components/ModalLayout';
import { useRef } from 'react';

const CaravanAgentInformation = ({ onClose }) => {
  const admin = useSelector((store) => store.admin.data);
    const ModalLayoutQuestionInputRef = useRef();
  const dispatch = useDispatch();

  const { t } = useTranslation();
  const queryParams = useParams();
  const paramId = queryParams?.id;

  const navigate = useNavigate();

  const backUrl = `${Enum.routes.root}`;
  const methods = useForm({
    resolver: yupResolver(validation.schema(paramId)),
    defaultValues: validation.defaultValue
  });

  const handleQuestionModal = (params) => ModalLayoutQuestionInputRef.current.show((p) => !p, params);
  

  const {
    reset,
    watch,
    control,
    setValue,
    setError,
    handleSubmit,
    getValues,
    formState: { errors, isSubmitting },
  } = methods;

  // ----------------------------------------------------------------------------- SERVICE
  const updating = (params) => axiosInstance.post(`admin/profile`, params);
  // ------------------------------------------------------------------------------ Mutation
  const onSuccessMutating = async () => {
    toast.success(t('successfully'));
    // const values = getValues();
    // if (values[validation.fieldNames.email] === admin?.email) {
    //   dispatch(getAdminProfile())
    // }
    await dispatch(getAdminProfile())
    navigate("/");
  };
  // const onErrorMutating = (error) => {
  //   console.log('* * * onErrorMutating :', { error });
  //   const errorTitle = error.response.data.message || t('errorTryAgain');
  //   const errors = Object.values(error?.response?.data?.errors || {});
  //   if (errors?.length) {
  //     errors?.map((x) => {
  //       return toast.error(x?.[0]);
  //     });
  //   } else toast.error(errorTitle);
  // };
  const { isLoading, mutate } = useMutationCustom({
    url: updating,
    name: `${Enum?.api?.base}_update`,
    invalidQuery: `${Enum?.api?.base}_get`,
    onSuccess: onSuccessMutating,
    // onError: onErrorMutating,
  });

  // ---------------------------------------

  const onSubmit = async () => {
    handleQuestionModal();
    const values = getValues();
    console.log('* * * onSubmit : ', { values });

    const reqData = new FormData();

    // const reqData = {
    //   [validation.fieldNames.name]: values[validation.fieldNames.name],
    //   [validation.fieldNames.last_name]: values[validation.fieldNames.last_name],
    //   [validation.fieldNames.phone]: persianToEnglishNumber(values[validation.fieldNames.phone]),
      
    // };

    reqData.append([validation.fieldNames.name] , values[validation.fieldNames.name])
    reqData.append([validation.fieldNames.last_name] , values[validation.fieldNames.last_name])
    reqData.append([validation.fieldNames.phone] , values[validation.fieldNames.phone])
    reqData.append([validation.fieldNames.image] , values[validation.fieldNames.image])
    reqData.append([validation.fieldNames.shenasname_image] , values[validation.fieldNames.shenasname_image])

    mutate(reqData);
  };
  console.log({ queryParams });
  return (
    <>
      <ModalLayout ref={ModalLayoutQuestionInputRef}>
        <QuestionComponent
          {...{
            title:'آیا از تایید اطلاعات خود مطمئن هستید؟',
            description: "",
            button: {
              confirm: {
                label: 'question.yesProcess',
                onClick: (_, data) => onSubmit(data),
              },
              reject: {
                label: 'question.no',
                onClick: () => handleQuestionModal(),
              },
            },
          }}
        // onClose={() => handleQuestionModal()}
        />
      </ModalLayout>
      <Container
        sx={{
          mt: 7
        }}
      >
        <Card>
          <Box
            sx={{
              width: '100%',
              // display: { xs: 'block', md: 'flex' },
              gap: 2,
              bgcolor: 'background.paper',
              borderRadius: 1,
              p: 4,
            }}
          >
            <HeaderBreadcrumbs
              // back={`${Enum.routes.root}`}
              heading={"تکمیل اطلاعات"}
            >
              {/* <Typography sx={{ mt: 1 }}>{resQuery?.data?.data?.name}</Typography> */}
            </HeaderBreadcrumbs>
            {/* <Box
              sx={{
                textAlign: 'center',
                mb: '30px',
              }}
              onClick={() => navigate(backUrl)}
            >
              <Typography variant="h5">{'شما در حال ایجاد یک دوره جدید هستید!'}</Typography>
            </Box> */}

            <FormProvider methods={methods} onSubmit={handleSubmit(handleQuestionModal)}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 3,
                }}
              >
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <RHFTextField name={validation.fieldNames.name} label={'نام'} />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <RHFTextField name={validation.fieldNames.last_name} label={'نام خانوادگی'} />
                  </Grid>
                  {/* <Grid item xs={12} md={6}>
                    <RHFTextField name={validation.fieldNames.code_melli} label={'کدملی'} />
                  </Grid> */}

                  <Grid item xs={12} md={6}>
                    <RHFTextField name={validation.fieldNames.phone} label={'موبایل'} />
                  </Grid>
                  {/* <Grid item xs={12} md={6}>
                    <RHFTextField name={validation.fieldNames.email} label={'ایمیل'} />
                  </Grid> */}
                  <Grid item xs={12} md={12}>
                    {/* <RHFTextField name={validation.fieldNames.email} label={'عکس پرسنلی'} /> */}
                    <RHFUploadSingleFile
                      name={validation.fieldNames.image}
                      title={'عکس پرسنلی'}
                      required
                      description={`فایل را بکشید و رها کنید یا روی دکمه انتخاب فایل کلیک کنید.
                    حداکثر حجم قابل قبول برای هر عکس: 5 مگابایت
                    فرمت های قابل قبول: gif، JPG، PNG،`}
                    // disabled={disabled}
                    />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    {/* <RHFTextField name={validation.fieldNames.email} label={'عکس پرسنلی'} /> */}
                    <RHFUploadSingleFile
                      name={validation.fieldNames.shenasname_image}
                      title={'عکس صفحه اول شناسنامه'}
                      required
                      description={`فایل را بکشید و رها کنید یا روی دکمه انتخاب فایل کلیک کنید.
                    حداکثر حجم قابل قبول برای هر عکس: 5 مگابایت
                    فرمت های قابل قبول: gif، JPG، PNG،`}
                    // disabled={disabled}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} textAlign="center">
                  <LoadingButton type="submit" variant="contained" color={'success'} loading={isLoading}>
                    {'ثبت اطلاعات'}
                  </LoadingButton>
                </Grid>
              </Box>

            </FormProvider>
          </Box>
        </Card>
      </Container>
    </>
  );
};

export default CaravanAgentInformation;
